import { getStoreId } from "$/hooks/use-store-information"
import juloUpdateQueries from "$/lib/queries/julo-update-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/julo-updates")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()

    if (storeId)
      queryClient.prefetchQuery(juloUpdateQueries.readStatuses(storeId))
    return { crumb: "alfred.pages.juloUpdates.crumbs.juloUpdates" }
  },
})
